import { render, staticRenderFns } from "./JobAssignedVisitPointPickup.vue?vue&type=template&id=5dca0978&scoped=true"
import script from "./JobAssignedVisitPointPickup.vue?vue&type=script&lang=js"
export * from "./JobAssignedVisitPointPickup.vue?vue&type=script&lang=js"
import style0 from "./JobAssignedVisitPointPickup.vue?vue&type=style&index=0&id=5dca0978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca0978",
  null
  
)

export default component.exports